import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import lists from './ListsReducer';
import currentUserLists from './CurrentUserListsReducer';

export default combineReducers(
  Immutable.Map({
    lists,
    currentUserLists
  })
);
